import { ButtonCall } from '../../components/seller-list-card/components/ButtonCall';
import { ButtonCallback } from '../../components/seller-list-card/components/ButtonCallback';
import { ButtonMessage } from '../../components/seller-list-card/components/ButtonMessage';
import { ButtonRequestQuote } from '../../components/seller-list-card/components/ButtonRequestQuote';
import { MarketplaceEnquiriesFeedback } from '../../components/seller-list-card/components/MarketplaceEnquiriesFeedback';
import { Booking } from '../../components/seller-list-card/components/Booking';

export const separationListMobileButtons = (experiments) => [
	new ButtonCallback(
		'button-callback',
		{
			dynamicClasses: 'w-auto flex-grow-1',
			isMobile: true,
		},
		experiments,
	),
	new ButtonCall(
		'button-call',
		{
			dynamicClasses: 'w-auto flex-grow-1',
			isMobile: true,
		},
		experiments,
	),
	new MarketplaceEnquiriesFeedback(
		'marketplace-feedback',
		{
			dynamicClasses: 'w-auto flex-grow-1',
			isMobile: true,
		},
		experiments,
	),
];

export const separationListTabletButtons = (experiments) => [
	new ButtonCall(
		'button-call',
		{ dynamicClasses: 'w-100', wrapperClasses: 'cta-mw-160 ml-auto', isTablet: true },
		experiments,
	),
	new ButtonCallback(
		'button-callback',
		{ dynamicClasses: 'w-100', wrapperClasses: 'cta-mw-160 ml-2', isTablet: true },
		experiments,
	),
	new Booking('bookings', {}, experiments),
];

export const separationListDesktopButtons = (experiments) => [
	new ButtonCall(
		'button-call',
		{ dynamicClasses: 'w-100', isDesktop: true },
		experiments,
	),
	new ButtonCallback(
		'button-callback',
		{ dynamicClasses: 'w-100', isDesktop: true },
		experiments,
	),
	new MarketplaceEnquiriesFeedback(
		'marketplace-feedback',
		{ dynamicClasses: 'w-100', isDesktop: true },
		experiments,
	),
	new Booking('bookings', {}, experiments),
];
